import { createAsyncThunk } from "@reduxjs/toolkit";

import { getTickers, getSharesPurchased, getAmountInvested, getCurrenciesName } from "../services";
import { companySettingsSelector } from "../store/slice/settings";

export const getTickersAction = createAsyncThunk("trade/tickers", async (ids = [], { getState }) => {
  const settings = companySettingsSelector(getState());
  const tickers = await getTickers(ids);

  // replace custom field from settings
  tickers.data.instruments.map(item => {
    const instrumentSetting = settings.instruments.find(({ id }) => item.instrumentId === id);

    if (instrumentSetting) {
      item.ticker = instrumentSetting.ticker ?? item.ticker;
      item.currencyCode = instrumentSetting.currencyCode ?? item.currencyCode;
      item.marketName = instrumentSetting.marketName ?? item.marketName;
      item.shareName = instrumentSetting.shareName ?? item.shareName;
      item.marketAbbreviation = instrumentSetting.marketAbbreviation ?? item.marketAbbreviation;
      item.order = instrumentSetting.order === null ? 0 : instrumentSetting.order;
    }

    return item;
  });
  tickers.data.instruments = tickers.data.instruments.sort((a, b) => {
    return a.order - b.order;
  });
  return tickers;
});

export const getAmountInvestedAction = createAsyncThunk("trade/getAmountInvested", async params => {
  const data = await getAmountInvested(params);
  return { query: params, ...data };
});

export const getSharesPurchasedAction = createAsyncThunk("trade/getSharesPurchased", async params => {
  const data = await getSharesPurchased(params);
  return { query: params, ...data };
});

export const getCurrenciesNameAction = createAsyncThunk("currency/getCurrenciesName", async currencies => {
  return await getCurrenciesName(currencies);
});
